import type { QueryClient } from "@tanstack/react-query";
import type { NavigateFn } from "@tanstack/react-router";
import { getImageByIdApiImagesImageIdGetQueryKey } from "../generated/api/@tanstack/react-query.gen";
import type { HydratedImage } from "../generated/api/types.gen";

export function navigateUndo(
  image: HydratedImage,
  queryClient: QueryClient,
  navigate: NavigateFn,
) {
  if (!image.parent_image_id) return;
  queryClient.invalidateQueries({
    queryKey: getImageByIdApiImagesImageIdGetQueryKey({
      path: { image_id: image.parent_image_id },
    }),
  });
  navigate({
    to: "/refine",
    search: {
      imageId: image.parent_image_id,
      sessionId: image.session_id,
    },
  });
}

export function navigateRedo(image: HydratedImage, navigate: NavigateFn) {
  if (!image.latest_child_image_id) return;
  navigate({
    to: "/refine",
    search: {
      imageId: image.latest_child_image_id,
      sessionId: image.session_id,
    },
  });
}
